import './styles/app.scss'

const toggleElement = document.getElementById("toggle");
const navElement = document.getElementById("nav")
const navContainerElement = document.getElementById("nav-container")

function handleToggleClick(this: HTMLElement, ev: HTMLElementEventMap["click"]) {
    document.body.classList.toggle("no-scroll");
    navContainerElement?.classList.toggle("open");
    navElement?.classList.toggle("open");
}

if (toggleElement != null) {
    toggleElement.addEventListener("click", handleToggleClick)
}